export class Message {
    constructor(
        public senderEmailAddress: string,
        public senderFirstName: string,
        public senderLastName: string,
        public message: string
    ) {}
}
